import { useI18n } from '@/i18n'
import type { Watch } from '@/types'

/**
 * The specification list. The fixed columns of the table come first (they exist
 * on every piece), then whatever free-form rows the owner typed into `specs`.
 */
export function SpecTable({ watch }: { watch: Watch }) {
  const { t } = useI18n()

  const fixed: { label: string; value: string }[] = [
    { label: t('watch.reference'), value: watch.reference },
    { label: t('movement.label'), value: t(`movement.${watch.movement}`) },
    { label: t('watch.caseMaterial'), value: watch.case_material },
    { label: t('watch.caseSize'), value: watch.case_size },
    { label: t('watch.water'), value: watch.water_resistance },
    { label: t('watch.strap'), value: watch.strap },
    { label: t('watch.year'), value: watch.year },
    { label: t('condition.label'), value: t(`condition.${watch.condition}`) },
  ]

  const rows = [...fixed, ...(Array.isArray(watch.specs) ? watch.specs : [])].filter(
    (r) => r.value && r.value !== '—',
  )

  return (
    <dl
      data-upbo-type="container"
      data-upbo-label="Specification"
      className="grid sm:grid-cols-2 gap-x-10"
    >
      {rows.map((row, i) => (
        <div key={`${row.label}-${i}`} className="flex items-baseline justify-between gap-4 py-3 border-b border-border">
          <dt className="text-[11px] uppercase tracking-[0.14em] text-text-faint shrink-0">{row.label}</dt>
          <dd className="text-[13px] text-text text-right">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
